import apiInstance from "../api";
import fileApiInstance from "../fileApi";
import endPoints from "../endpoints";

export const getEmployeePlanWithdrawals = (id) => {
  return apiInstance().get(
    `${endPoints.withdrawal.getEmployeePlanWithdrawals}/${id}`
  );
};

export const addAddress = (payload) => {
  return apiInstance().post(endPoints.withdrawal.addAddress, payload);
};

export const addBank = (payload) => {
  return apiInstance().post(endPoints.withdrawal.addBank, payload);
};

export const saveWithdrawalRequest = (payload) => {
  return apiInstance().post(
    endPoints.withdrawal.saveWithdrawalRequest,
    payload
  );
};

export const getWithdrawalRequest = (id) => {
  return apiInstance().get(
    `${endPoints.withdrawal.getWithdrawalRequest}/${id}`
  );
};

export const getPeriodicPaymentCalculationDetails = (planId, censusId) => {
  return apiInstance().get(
    `${endPoints.withdrawal.getPeriodicPaymentCalculationDetails}/${planId}/${censusId}`
  );
};

export const getLoanDetailsById = (id) => {
  return apiInstance().get(`${endPoints.transactions.getLoanById}/${id}`);
};

export const getLoanSummaryDetails = (id) => {
  return apiInstance().get(`${endPoints.transactions.getLoanSummary}/${id}`);
};

export const getLoanSummaryById = (id) => {
  return apiInstance().get(`${endPoints.transactions.getLoanById}/${id}`);
};

export const getAmortizationSchedule = (id) => {
  return apiInstance().get(
    `${endPoints.transactions.getAmortizationSchedule}/${id}`
  );
};

export const getRepaymentSchedule = (id) => {
  return apiInstance().get(
    `${endPoints.transactions.getRepaymentSchedule}/${id}`
  );
};

export const getStateTax = (id) => {
  return apiInstance().get(`${endPoints.withdrawal.getStateTax}/${id}`);
};

export const getWithdrawalByEmployeeId = (employeeid) => {
  return apiInstance().get(
    `${endPoints.withdrawal.getWithdrawalByEmployeeId}/${employeeid}`
  );
};

export const getLoanByEmployeeId = (employeeid) => {
  return apiInstance().get(
    `${endPoints.transactions.GetLoanByEmployeeId}/${employeeid}`
  );
};

export const submitWithdrawalRequest = (id) => {
  return apiInstance().get(
    `${endPoints.withdrawal.submitWithdrawalRequest}/${id}`
  );
};

export const approvalWithdrawalRequest = (payload) => {
  return apiInstance().post(
    endPoints.withdrawal.approvalWithdrawalRequest,
    payload
  );
};

export const saveInProgressLoanRequest = (payload) => {
  return apiInstance().post(endPoints.transactions.saveInProgressLoan, payload);
};

export const submitLoanRequestById = (id) => {
  return apiInstance().post(endPoints.transactions.submitLoanRequest, id);
};
export const getEligibleParticipantsForRMD = (isMissed) => {
  return apiInstance().get(
    `${endPoints.withdrawal.getEligibleParticipantsForRMD}/${isMissed}`
  );
};
export const getEligibleParticipantsForForceOut = () => {
  return apiInstance().get(`${endPoints.withdrawal.getForcedOutParticipants}`);
};
export const uploadWithdrawalDocumentsRequest = (payload) => {
  return apiInstance().post(
    endPoints.withdrawal.uploadWithdrawalDocuments,
    payload,
    {
      headers: { "content-type": "multipart/form-data" },
    }
  );
};

export const uploadLoanDocumentsRequest = (payload) => {
  return apiInstance().post(
    endPoints.transactions.uploadLoanDocuments,
    payload,
    {
      headers: { "content-type": "multipart/form-data" },
    }
  );
};
export const loanDownloadTemplate = (id) => {
  return fileApiInstance().get(
    `${endPoints.transactions.loanDownloadTemplate}/${id}`
  );
};

export const getBalances = (id) => {
  return apiInstance().get(`${endPoints.rkaas.getBalances}/${id}`);
};
